import { IconEdit, IconLoader, IconPlus, IconX } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Control, FieldValues, set, useForm } from 'react-hook-form'
import { useBranchAPI } from 'src/API/rest.branch'
import { useProductCategoryAPI } from 'src/API/rest.product_category'
import { useDepartmentAPI } from 'src/API/rest.department'
import { useProductAPI } from 'src/API/rest.products'
import { ButtonIconSquare } from 'src/components/buttons'
import { InputStandard, TextAreaStandard } from 'src/components/standard.input'
import { ModalStandard, ModalStandardContent, ModalStandardDescription, ModalStandardFooter, ModalStandardHeader, ModalStandardTitle, ModalStandardTrigger } from 'src/components/standard.modal'
import { SelectStandard } from 'src/components/standard.select'
import { SwitchDemo } from 'src/components/standard.switch'
import { Input } from 'src/shadcn/ui/input'
import { Label } from 'src/shadcn/ui/label'
import { DialogFooter } from 'src/shadcn/ui/react-dialog'
import { toast } from 'src/shadcn/ui/use-toast'
import { useProductSubCategoryAPI } from 'src/API/rest.product_sub_category'
import { ImageBox } from 'src/components/image_box'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'

type Props = {

    show?: boolean,
    setShow?: (show: boolean) => void,
    refetchProducts: () => void,
    mode: 'add' | 'edit',
    productId?: number | string | null
}
type ProductData = {
    id?: number,
    name: string | null,
    image: string | File,
    price: string | null,
    description: string | null,
}

export function ModalAddProduct(props: Props) {

    const { register, handleSubmit, setValue, reset, formState: { errors }, control, watch } = useForm<ProductData>({
        defaultValues: {
            description: '',
            name: '',
            price: '',
            image: ''
        }
    });

    const [selectedImageLink, setSelectedImageLink] = useState<string>()



    const [isSubmitting, setIsSubmitting] = React.useState(false);


    const [selectedImage, setSelectedImage] = useState<File>()

    const {
        readProductbyId,
        createProduct,
        updateProduct,
        isReadingProduct,
        isFetching: isProductFetching
    } = useProductAPI({})


    useEffect(
        () => {
            console.log(props.show)
            if (props.show && props.mode === 'add') {
                reset({
                    description: '',
                    name: '',
                    price: '',
                    image: ''
                })
            }
            if (props.mode === 'edit' && props.productId && props.show) {
                const getProductById = async () => {
                    if (!props.productId) {
                        return
                    }
                    const response = await readProductbyId({ productId: props.productId }) 
                    if (response.success !== false) {
                        reset({
                            description: response.description,
                            name: response.name,
                            price: response.price,
                            image: response.image ||''
                        })
                        setSelectedImageLink(response.image?`${process.env.REACT_APP_BACKEND_URL}/${response.image}`:undefined)
                    } else {
                        toast({
                            description: response.message,
                            title: "error",
                            // variant:''
                        })
                    }
                }
                getProductById()
            }
        }, [props.show]
    )

    const onSubmit = async (data: ProductData) => {

        

        setIsSubmitting(true)
        if (props.mode === 'add') {

            if(!selectedImage){
                toast({
                    description: 'Please select an image',
                    title: "error",
    
                })
                return
            }


            const response = await createProduct({
                description: data.description,
                name: data.name,
                price: data.price,
                image: selectedImage!
            } )
            if (response.success !== false) {
                toast({
                    description: 'Product added successfully',
                    // variant:''
                })
                props.setShow?.(false);
                props.refetchProducts()
            } else {
                toast({
                    description: response.message,
                    title: "error",
                    // variant:''
                })
            }
        } else if (props.mode === 'edit' && props.productId) {
            const response = await updateProduct({
                id: props.productId,
                Product: {
                    description: data.description,
                    name: data.name,
                    price: data.price,
                    image: selectedImage!
                }
            })
            if (response.success !== false) {
                toast({
                    description: 'Product updated successfully',
                    // variant:''
                })
                props.setShow?.(false);
                props.refetchProducts()
            } else {
                toast({
                    description: 'Error updating product',
                    title: "error",
                    // variant:''
                })
            }
        }
        setIsSubmitting(false)
    };

    const isAnyThingLoading = isReadingProduct || isProductFetching

    return (
        <ModalStandard
            open={props.show}
            onOpenChange={props.setShow}
        >
            <ModalStandardContent onOpenAutoFocus={(e) => e?.preventDefault()} className='bg-vstargray-100'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalStandardHeader >
                        <ModalStandardTitle >{props.mode === 'edit' ? 'Edit Product' : 'Add Product'}</ModalStandardTitle>
                        <ModalStandardDescription>
                            {/* loading indication */}
                            {isAnyThingLoading && <div className=' px-2 p-1 rounded-md bg-vstargray-800/30 whitespace-nowrap w-min absolute left-1/2 -translate-x-1/2'>
                                Updating...
                            </div>}
                            <form onSubmit={handleSubmit(onSubmit)} className=" pb-3">
                                <div className='grid gap-4 py-4 xs2:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 '>
                                    <div className=" lg:col-span-1 xl:col-span-1">
                                        <InputStandard
                                            placeholder='name'
                                            title='Product name'
                                            {...register("name", { required: "Product name is required" })}
                                            error={errors.name?.message}
                                            disabled={isAnyThingLoading}
                                        />
                                    </div>
                                    <div className=" lg:col-span-1 xl:col-span-1">
                                        <InputStandard
                                            placeholder='price'
                                            title='Product Price'
                                            {...register("price", { required: "Product price is required", })}
                                            error={errors.price?.message}
                                            disabled={isAnyThingLoading}
                                        />
                                    </div>
                                    <div className=" lg:col-span-1 xl:col-span-1">
                                        <TextAreaStandard
                                            placeholder='description'
                                            title='Product Description'
                                            {...register("description", { required: "Product description is required" })}
                                            error={errors.description?.message}
                                            disabled={isAnyThingLoading}
                                        />
                                    </div>



                                    <div className=" lg:col-span-1 xl:col-span-1">
                                        {
                                            selectedImageLink ?
                                                <ImageBox
                                                    height={200}
                                                    width={200}
                                                    imagelink={selectedImageLink}
                                                    onDelete={() => {
                                                        setSelectedImageLink(undefined)
                                                        setSelectedImage(undefined)

                                                    }}
                                                />
                                                : <FileInputDragDropStandard
                                                    title=' '
                                                    description=' '
                                                    onDrop={(file) => {
                                                        if (file[0].size > 1048576) {
                                                            toast({
                                                                description: 'Image size should not be above 1MB'
                                                            })
                                                            return;
                                                        }
                                                        // File type validation
                                                        const allowedFileTypes = ['image/png', 'image/jpg', 'image/jpeg'];
                                                        if (!allowedFileTypes.includes(file[0].type)) {
                                                            toast({
                                                                description: 'Only PNG, JPG, and JPEG files are allowed'
                                                            });
                                                            return;
                                                        }
                                                        // Create Blob URL for shorter link
                                                        const blobUrl = URL.createObjectURL(file[0]);
                                                        setSelectedImageLink(blobUrl)
                                                        setSelectedImage(file[0]);
                                                    }}
                                                    onClear={() => setSelectedImage(undefined)}
                                                    file={selectedImage}
                                                />
                                        }

                                    </div>

                                </div>

                            </form>
                        </ModalStandardDescription>
                    </ModalStandardHeader>
                    <ModalStandardFooter>
                        <ButtonIconSquare
                            variant='white'
                            icon={<IconX />}
                            text='close'
                            onClick={(e) => { e?.preventDefault(); props.setShow?.(false) }}
                            disabled={isSubmitting}
                        />
                        <ButtonIconSquare
                            variant='secondary'
                            icon={isSubmitting ? <IconLoader className=' animate-spin ' /> : props.mode === 'add' ? <IconPlus /> : <IconEdit />}
                            text={props.mode === 'add' ? 'Add' : 'Edit'}
                            type="submit"
                            disabled={isSubmitting}
                        />
                    </ModalStandardFooter>
                </form>
            </ModalStandardContent>
        </ModalStandard>
    )
}


